import React from 'react';
import {pageData} from '../../constants/pagedata';
import {PagePicker} from '../../components/pagepicker';
import { ContentPicker } from '../../components/contentpicker';
import {LinkWrapper} from './linkwrapper';
import { ALL_GAMES_LIST } from '../../constants/textcontent';

const LINK_INTRO:string="Get a link to a page";

const LINK_COPY="You can use this page to create shareable links to the games on this site.  For some of the games, it is useful to preselect the image content that the game will use.  If you have uploaded your own image content, then you can create a link that uses that content in the game.";

const CHOOSE_MSG:string="Choose a page";

interface StateType{
	pageSelected:string,
	contentSelected:string[],
}

interface PropsType{
	usermail:string,
	userContentList:string[]
}

export default class GetLink extends React.Component<PropsType>{

	public state:StateType;

	constructor(props:PropsType){
		super(props);
		this.state={
			pageSelected:'',
			contentSelected:['','']
		}

		this.pageClick=this.pageClick.bind(this);
		this.contentClick=this.contentClick.bind(this);
	}

	pageClick(pageClicked:string){
		if(pageClicked!==this.state.pageSelected){
			this.setState({pageSelected:pageClicked,contentSelected:['','']});
		}else{
			this.setState({pageSelected:'',contentSelected:['','']});
		}
	}
  
	contentClick(contentSelected:string[]){
		if(contentSelected[0]===this.state.contentSelected[0]&&contentSelected[1]===this.state.contentSelected[1]){
			this.setState({contentSelected:['','']});
		}else{
			this.setState({contentSelected:contentSelected});
		}
	}

	render() {
		let contentGroup=0;
		if(this.state.pageSelected!=='')contentGroup=pageData[this.state.pageSelected].contentGroup;
		let showChooseContentMsg=contentGroup!==0;
		return (
			<div id='teachers-getlink'>
				<hr />
				<h3>{LINK_INTRO}</h3>
				<p>{LINK_COPY}</p>
				<h4>{CHOOSE_MSG}</h4>
				<PagePicker
					pageClick={this.pageClick} 
					pageSelected={this.state.pageSelected}
					showList={ALL_GAMES_LIST} />
				{showChooseContentMsg&&<hr />}
				{showChooseContentMsg&&<h4>Choose content to use</h4>}
				<ContentPicker
					pageSelected={this.state.pageSelected}
					contentClick={this.contentClick}
					userContentList={this.props.userContentList}
					contentSelected={this.state.contentSelected}/>
				<hr />
				<LinkWrapper
					pageSelected={this.state.pageSelected}
					usermail={this.props.usermail}
					contentSelected={this.state.contentSelected}/>
			</div>
		);
	}
}
